import axios from 'axios';

// const API_URL = process.env.REACT_APP_API_URL;
const API_URL = "https://myapp.daqtank.ng/api";

export const PublicApi = axios.create({
  baseURL: API_URL,
  // headers: {
  //   'Content-Type': 'application/json',
  // },
});